import { render, staticRenderFns } from "./Installation.vue?vue&type=template&id=48d65094&scoped=true&lang=pug"
import script from "./Installation.vue?vue&type=script&lang=js"
export * from "./Installation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d65094",
  null
  
)

export default component.exports